import React, { useState } from 'react';
import { IContractFile } from '../../../public/APIContracts/APIContracts';
import Row from 'src/components/Row';
import FontAwesomeIcon from 'src/components/Icon';
import ContractFileTile from 'src/components/ContractFileTile/ContractFileTile';
import './contract-files-repeater.scss';

interface IContractFilesRepeaterProps {
  contractFiles: IContractFile[];
  onFileClick?: (file: IContractFile, index: number) => void;
  small?: boolean;
  defaultExpanded?: boolean;
}

export const ContractFilesRepeater = ({
  contractFiles,
  small = false,
  defaultExpanded = false,
}: IContractFilesRepeaterProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleFileClick = (file: IContractFile, index: number) => {
    // Open file in new tab.
    if (file.file_url) {
      window.open(file.file_url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="contract-file-repeater">
      <div
        className="document-group__expanding-header"
        onClick={() => setExpanded(!expanded)}
      >
        <FontAwesomeIcon
          glyph={expanded ? 'caret-down' : 'caret-right'}
          weight={expanded ? 'solid' : 'light'}
        />
        <h3>Contract Files</h3>
      </div>
      {expanded && (
        <div className="repeating-contract-files-container">
          <Row>
            {contractFiles?.map((file: IContractFile, index: number) => (
              <div key={`contract-file-${file.id}-${index}`}>
                <div style={{ padding: '1rem' }}>
                  <ContractFileTile
                    contractFile={file}
                    onClick={() => handleFileClick(file, index)}
                    small={small}
                    active={false}
                  />
                </div>
              </div>
            ))}
          </Row>
        </div>
      )}
    </div>
  );
};
